import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import './AddCategoryAndItems.css'; // Import the styles

const AddCategoryAndItems = () => {
    const navigate = useNavigate();
    
    const [categoryName, setCategoryName] = useState('');
    const [categoryImage, setCategoryImage] = useState(null);
    const [categoryDescription, setCategoryDescription] = useState('');
    const [itemName, setItemName] = useState('');
    const [itemPrice, setItemPrice] = useState('');
    const [itemImage, setItemImage] = useState(null);
    const [itemDescription, setItemDescription] = useState('');
    const [itemQuantity, setItemQuantity] = useState('');
    const [itemCategory, setItemCategory] = useState('Sélectionner une catégorie');
    const [categoryPreviewImage, setCategoryPreviewImage] = useState("https://storage.googleapis.com/uxpilot-auth.appspot.com/c5f6ebf80c-617e01d44622a647b2ab.png");
    const [itemPreviewImage, setItemPreviewImage] = useState("https://storage.googleapis.com/uxpilot-auth.appspot.com/7f73ed7ef9-7aa5e7028ea112bb7736.png");
    const [ownerId, setOwnerId] = useState(null);
console.log("id",ownerId)
    const fileInputRef = useRef(null);
    const fileInputRefItem = useRef(null);
    const API_URL = process.env.REACT_APP_API_URL;

   useEffect(() => {
       const token = localStorage.getItem("ownerToken");
       if (token) {
         try {
           const decodedToken = jwtDecode(token);
           setOwnerId(decodedToken.id);
         } catch (error) {
           console.error("Erreur lors du décodage du jeton:", error);
         }
       }
     }, []);

    const handleCategoryNameChange = (e) => {
        setCategoryName(e.target.value);
    };

    const handleCategoryDescriptionChange = (e) => {
        setCategoryDescription(e.target.value);
    };

    const handleCategoryImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCategoryImage(file);
            setCategoryPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleItemNameChange = (e) => {
        setItemName(e.target.value);
    };

    const handleItemPriceChange = (e) => {
        setItemPrice(e.target.value);
    };

    const handleItemImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setItemImage(file);
            setItemPreviewImage(URL.createObjectURL(file));
        }
    };

    const handleItemDescriptionChange = (e) => {
        setItemDescription(e.target.value);
    };

    const handleItemQuantityChange = (e) => {
        setItemQuantity(e.target.value);
    };

    const handleItemCategoryChange = (e) => {
        setItemCategory(e.target.value);
    };

    const handleAddCategory = async () => {
        if (!categoryName) {
            alert("Le nom de la catégorie est requis");
            return;
        }

        const formData = new FormData();
        formData.append('category', categoryName);
        if (categoryImage) {
            formData.append('itemImg', categoryImage); // Assuming your backend expects 'itemImg' for the image
        }
        formData.append('ownerId', ownerId); // Include ownerId in the form data

        try {
            const response = await fetch(`${API_URL}/api/addCategory`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                alert("Catégorie ajoutée avec succès!");
                // Reset the form
                setCategoryName('');
                setCategoryImage(null);
                setCategoryPreviewImage("https://storage.googleapis.com/uxpilot-auth.appspot.com/c5f6ebf80c-617e01d44622a647b2ab.png");
                setCategoryDescription('');
            } else {
                const errorData = await response.json();
                alert(`Erreur lors de l'ajout de la catégorie: ${errorData.message || 'Une erreur s\'est produite'}`);
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout de la catégorie:", error);
            alert("Une erreur s'est produite. Veuillez réessayer.");
        }
    };

    const handleAddItem = async () => {
        if (!itemName || !itemImage) {
            alert("Le nom et l'image de l'article sont obligatoires");
            return;
        }

        const formData = new FormData();
        formData.append('itemName', itemName);
        formData.append('itemImg', itemImage);
        formData.append('ownerId', ownerId); // Include ownerId
        formData.append('category', categoryName);
        // formData.append('price', itemPrice);
        // formData.append('description', itemDescription);
        // formData.append('quantity', itemQuantity);
        //formData.append('category', itemCategory);
console.log("formData",formData)
        try {
            const response = await fetch(`${API_URL}/api/addCategory`, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                alert("Article ajouté avec succès!");
                // Reset the form
                setItemName('');
                setItemImage(null);
                setItemPreviewImage("https://storage.googleapis.com/uxpilot-auth.appspot.com/7f73ed7ef9-7aa5e7028ea112bb7736.png");
                setItemPrice('');
                setItemDescription('');
                setItemQuantity('');
                setItemCategory('Select category');
            } else {
                const errorData = await response.json();
                alert(`Erreur lors de l'ajout de l'article: ${errorData.message || 'Une erreur s\'est produite'}`);
            }
        } catch (error) {
            console.error("Erreur lors de l'ajout de l'article:", error);
            alert("Une erreur s'est produite. Veuillez réessayer.");
        }
    };

    const handleCategoryImageClick = () => {
        fileInputRef.current.click();
    };

    const handleItemImageClick = () => {
        fileInputRefItem.current.click();
    };

    const handleAddItems = () => {
        navigate("/AddItems"); // Redirects to the /orderdetails route
      };
      

    return (
        <div id="app-container" className="app-container">
            {/* Header */}
            <header id="header" className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="header-left">
                            <div id="logo" className="logo">Lememeprix</div>
                            <div className="search-container">
                                <i className="fa-solid fa-location-dot search-icon"></i>
                            </div>
                        </div>
                        <div className="header-right">
                            <i className="fa-solid fa-cart-shopping cart-icon"></i>
                            <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg" alt="Profile" className="profile-image" />
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="main-content">
                {/* Category Entry Section */}
                <section id="category-entry" className="category-entry">
                    <div className="form-container">
                        <h2 className="section-title">Ajouter une nouvelle catégorie</h2>
                        <div className="form-grid">
                            <div className="form-inputs">
                                <div>
                                    <label className="form-label">Nom de la catégorie</label>
                                    <input
                                        type="text"
                                        placeholder="ex : Pains, Pâtisseries"
                                        className="form-input"
                                        value={categoryName}
                                        onChange={handleCategoryNameChange}
                                    />
                                </div>
                                {/* <div>
                                    <label className="form-label">Image de la catégorie</label>
                                    <div className="upload-box" onClick={handleCategoryImageClick}>
                                        <i className="fa-solid fa-cloud-arrow-up upload-icon"></i>
                                        <p>Drag & drop or click to upload</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            onChange={handleCategoryImageChange}
                                            ref={fileInputRef}
                                        />
                                    </div>
                                </div> */}
                                {/* <div>
                                    <label className="form-label">Description (Facultatif)</label>
                                    <textarea
                                        placeholder="Entrez la description de la catégorie"
                                        className="form-input"
                                        rows="3"
                                        value={categoryDescription}
                                        onChange={handleCategoryDescriptionChange}
                                    ></textarea>
                                </div> */}
                                {/* <button className="form-button" onClick={handleAddCategory}>Add Category</button> */}
                            </div>
                            {/* <div id="category-preview" className="category-preview">
                                <h3 className="preview-title">Live Preview</h3>
                                <div className="preview-card">
                                    <img
                                        className="preview-image"
                                        src={categoryPreviewImage}
                                        alt="modern minimalist bakery storefront with elegant display of pastries"
                                    />
                                    <h4 className="preview-name">{categoryName || "Category Name"}</h4>
                                    <p className="preview-description">{categoryDescription || "Category description preview..."}</p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                     {/* Add Items Section */}
                <div id="item-entry" className="item-entry">
                    <div className="form-container">
                        <h2 className="section-title">Ajouter un nouvel article</h2>
                        <div className="form-grid">
                            <div className="form-inputs">
                                <div className="input-row">
                                    <div>
                                        <label className="form-label">Nom de l'article</label>
                                        <input
                                            type="text"
                                            placeholder="Croissant au chocolat"
                                            className="form-input"
                                            value={itemName}
                                            onChange={handleItemNameChange}
                                        />
                                    </div>
                                    {/* <div>
                                        <label className="form-label">Prix (€)</label>
                                        <input
                                            type="text"
                                            placeholder="0.00"
                                            className="form-input"
                                            value={itemPrice}
                                            onChange={handleItemPriceChange}
                                        />
                                    </div> */}
                                </div>
                                <div>
                                    <label className="form-label">Image de l'article</label>
                                    <div className="upload-box" onClick={handleItemImageClick}>
                                        <i className="fa-solid fa-cloud-arrow-up upload-icon"></i>
                                        <p>Glissez-déposez ou cliquez pour télécharger</p>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            className="hidden"
                                            onChange={handleItemImageChange}
                                            ref={fileInputRefItem}
                                        />
                                    </div>
                                </div>
                                {/* <div>
                                    <label className="form-label">Description</label>
                                    <textarea
                                        placeholder="Entrez la description de l'article"
                                        className="form-input"
                                        rows="3"
                                        value={itemDescription}
                                        onChange={handleItemDescriptionChange}
                                    ></textarea>
                                </div> */}
                                <div className="input-row">
                                    {/* <div>
                                        <label className="form-label">Quantité disponible</label>
                                        <input
                                            type="number"
                                            className="form-input"
                                            value={itemQuantity}
                                            onChange={handleItemQuantityChange}
                                        />
                                    </div>
                                    <div>
                                        <label className="form-label">Catégorie</label>
                                        <select
                                            className="form-input"
                                            value={itemCategory}
                                            onChange={handleItemCategoryChange}
                                        >
                                            <option>Sélectionner une catégorie</option>
                                            <option>Pains</option>
                                            <option>Pâtisseries</option>
                                        </select>
                                    </div> */}
                                 </div>
                                 <button className="form-button" onClick={handleAddItem}>Ajouter un article</button>
                            </div>
                            <div id="item-preview" className="item-preview">
                                <h3 className="preview-title">Aperçu en direct</h3>
                                <div className="preview-card">
                                    <img
                                        className="preview-image"
                                        src={itemPreviewImage}
                                        alt="elegant chocolate croissant on marble surface with professional lighting"
                                    />
                                    <div className="preview-header">
                                        <h4 className="preview-name">{itemName || "Nom de l'article"}</h4>
                                        <span className="preview-price">€{itemPrice || "0.00"}</span>
                                    </div>
                                    {/* <p className="preview-description">{itemDescription || "Item description preview..."}</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
<button className="form-button" onClick={handleAddItems}>Retour au tableau de bord</button>

               
                </div>
                </section>

               

                {/* Summary Section */}
                <section id="summary" className="summary">
                    <div className="summary-container">
                        <div className="summary-grid">
                            <div className="summary-item">
                                <h3 className="summary-number">3</h3>
                                <p>Catégories ajoutées aujourd'hui</p>
                            </div>
                            <div className="summary-item">
                                <h3 className="summary-number">8</h3>
                                <p>Articles répertoriés</p>
                            </div>
                            <div className="summary-item">
                                <h3 className="summary-number">2 450 €</h3>
                                <p>Impact estimé sur le chiffre d'affaires</p>
                            </div>
                        </div>
                        <button className="summary-button">Enregistrer et publier le menu</button>
                    </div>
                </section>
            </main>

            {/* Footer */}
            <footer id="footer" className="footer">
                <div className="container">
                    <div className="footer-grid">
                        <div>
                            <h4 className="footer-title">À propos de Lememeprix</h4>
                            <ul className="footer-list">
                                <li><span className="footer-link">À propos de nous</span></li>
                                <li><span className="footer-link">Carrières</span></li>
                                <li><span className="footer-link">Presse</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="footer-title">Assistance</h4>
                            <ul className="footer-list">
                                <li><span className="footer-link">Centre d'aide</span></li>
                                <li><span className="footer-link">Contactez nous</span></li>
                                <li><span className="footer-link">Politique de confidentialité</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="footer-title">Pour les entreprises</h4>
                            <ul className="footer-list">
                                <li><span className="footer-link">Rejoindre en tant que partenaire</span></li>
                                <li><span className="footer-link">Pour les restaurants</span></li>
                                <li><span className="footer-link">Pour les chauffeurs</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="footer-title">Suivez-nous</h4>
                            <div className="footer-social">
                                <span className="footer-social-icon"><i className="fa-brands fa-instagram"></i></span>
                                <span className="footer-social-icon"><i className="fa-brands fa-facebook"></i></span>
                                <span className="footer-social-icon"><i className="fa-brands fa-twitter"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default AddCategoryAndItems;